export function resultIf<T = string>(condition: boolean, result: T) {
  if (condition) {
    return result;
  }
}